export const COLLAPSE_EVENT = 'collapse';
